import showContactForm from './show-contact-form';
import hideForm from './hide-form';
import preload from './preload';
import closeForm from './close-form';
import showForm from './show-form';

export default {
  showContactForm,
  hideForm,
  preload,
  closeForm,
  showForm,
};
